module.exports = __webpack_public_path__ + "img/fullscreen.6c5381c6.svg";